import React, { useState } from 'react';
import Slider from 'react-slick';
import 'theme/vendor/slick.min.scss';
import './Carousel.scss';
import { connect } from 'react-redux';

let currencyCode = '';
let currencySymbol = '';
const Carousel = React.forwardRef((props, ref) => {
  const {
    dataLocale,
    carouselHtmlData,
    carouselStyle = '',
    carouselConfig,
    currencyMark,
    carouselList,
    slidesToShow = 7,
    initialSlide = 1,
    changeCarouselSlide,
    responsive,
    imageKey,
    imageBorder = true,
    brand,
    price,
    carouselCss,
  } = props;
  const [currentSlide, setCurrentSlide] = useState(initialSlide);

  const changeSlide = index => {
    setCurrentSlide(index);
  };
  const onClickChangeSlide = (index, imageClick) => {
    setCurrentSlide(index);
    if (changeCarouselSlide) {
      changeCarouselSlide(index, imageClick);
    }
  };

  let config = {
    infinite: false,
    pauseOnHover: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  if (carouselHtmlData) {
    config = Object.assign({}, config, carouselConfig);
  }

  return carouselHtmlData ? (
    <>
      <style type="text/css">{carouselCss}</style>
      <div
        className={`slider-main carousel-comp-slider ${carouselStyle}`}
        style={{ width: '100%' }}
      >
        <Slider {...config} ref={ref}>
          {carouselHtmlData.map(data => {
            return data;
          })}
        </Slider>
      </div>
    </>
  ) : (
    <div className="slider-custom">
      <Slider
        style={{ display: 'flex', alignItems: 'center' }}
        {...config}
        ref={ref}
        autoplay={false}
        beforeChange={(current, next) => changeSlide(next)}
        initialSlide={initialSlide}
        responsive={responsive}
        slidesToShow={slidesToShow}
      >
        {carouselList.map((data, index) => {
          currencyCode =
            data.prices && data.prices.length > 0
              ? data.prices[1].currencyCode ||
                data.prices[1].currency_code ||
                dataLocale.CURRENCY_CODE
              : dataLocale.CURRENCY_CODE;
          currencySymbol =
            currencyCode !== 'INR' ? (
              <span>{currencyMark[currencyCode]}</span>
            ) : (
              <span>{currencyMark[dataLocale.CURRENCY_CODE]}</span>
            );
          return (
            <div key={index}>
              <div
                className={`small-carousel-img cursor-pointer ${
                  index === currentSlide && imageBorder ? 'border-blue' : null
                }`}
                style={{ border: !imageBorder ? 'none' : '', height: 'auto' }}
                onClick={() => onClickChangeSlide(index, 'imageClick')}
              >
                <img alt={index} src={data[imageKey]} />
                {brand && (
                  <div className="brand-name fs14 fw-bold text-center">{data.brandName}</div>
                )}
                {price && (
                  <div className="brand-name fs14 fw-bold text-center fw-bold">
                    {currencySymbol}
                    {data.prices[1].price}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
});

const mapStateToProps = state => ({
  currencyMark: state.common.currencyMark,
  dataLocale: state.locale,
});
export default connect(mapStateToProps, null)(Carousel);
